import { createNode } from '@glueapp/graph-types';

export const ToLowerCase = createNode({
    id: 'To Lower Case',
    name: 'To Lower Case',
    description: 'Changes all characters in a text to their lowercase equivalent',
    aiDescription: 'Converts a string to lowercase. Connect a string to "Input"; outputs the lowercased string on "Output".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: {
            kind: 'string',
        },
    },
    outPorts: {
        Output: {
            kind: 'string',
        },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input.toLocaleLowerCase() } };
    },
});
